<!--设备运行时间 deviceRunTime-->
<template>
  <div class="mymetermanager">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <span>设备名称：</span>
                <el-input v-model="searchItem" placeholder="请输入设备名称" style="width:140px;" show-word-limit></el-input>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div class="mytable" :style="{'height':heights+'px'}">
          <el-table :data="dataList.filter(res=>!searchItem || res.deviceName.includes(searchItem) )" :height="heights"
            border style="width: 100%;" stripe>
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column type="index" width="50" label="序号" fixed align="center">
            </el-table-column>
            <el-table-column prop="deviceName" label="设备名称" min-width="150">
            </el-table-column>

            <el-table-column prop="variableName" label="变量名称" min-width="190" />


            <el-table-column label="状态" width="100" align="center">
              <template #default="{row}">
                <span v-if="row.status" style="color:red;">
                  停止
                </span>
                <span v-else style="color: #87CF64;">
                  启动
                </span>
              </template>
            </el-table-column>


          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import elUnitTree from '@/components/module/newTree/elDeviceTreeRun.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      elUnitTree,
    },
    data () {
      return {
        clickItem: '',
        virtualDeviceList: [],
        searchItem: '',
        filterText: '',
        defaultProps: {
          children: 'ChildDatas',
          label: 'label'
        },
        treeList: [],
        temp: {},
        dialogStatus: '',
        dialogVisible: false,
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        rules: {
          totalTime: [
            {required: true,message: '请输入总时长',trigger: 'blur'}
          ],
          variableName: [
            {required: true,message: '请输入变量名称',trigger: 'change'}
          ],
          deviceName: [
            {required: true,message: '请输入设备名称',trigger: 'blur'}
          ],
          startTime: [
            {required: true,message: '请选择开始运行时间',trigger: 'change'}
          ],

        },

        heights: document.getElementById('app').clientHeight-240,
        treeListCopy: null,
        dataList: [],
        deviceNo: '',
        findDeviceName: '',
        ownerName: '',
        state: undefined,

        loading: false,//页面加载
      }
    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
    },
    mounted () {
      this.getList();
      this.getTree();
    },

    methods: {
      getTree () {
        request({url: "/catalogueRunningTime/getAllConfigs",method: "get"}).then(res => {
          if(res.code==200) {
            this.virtualDeviceList=res.data;
          }
        })
      },
      checkFun (val) {
        if(val) {
          this.clickItem=val;
          this.getList();
        }
      },
      //类型筛选
      screenType_fn (value) {
        var a=JSON.parse(JSON.stringify(this.treeListCopy))
        if(value=="") {
          this.treeList=a
          return
        }

        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.Content.Category=="Device") {
                row.ChildDatas=row.ChildDatas.filter(v => v.Content.Id==value)
              } else {
                if(row.ChildDatas==null) {
                  row.ChildDatas=[]
                }
                getStr(row.ChildDatas)
              }

            })
          }
          getStr(a)
        }
        recursiveFunction()

        this.treeList=a
      },
      //处理企业数据
      handleData (data) {
        data=JSON.parse(JSON.stringify(data).replace(/appTypes/g,'ChildDatas').replace(/groupName/g,"Name").replace(/groupIdAndName/g,"Content").replace(/groupId/g,"Id").replace(/appTypeInfo/g,"Content").replace(/appName/g,"Name"))
        var num=1
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas.length!=0) {
                getStr(row.ChildDatas)
              } else {
                row.ChildDatas=row.Content.groups
              }
            })
          }
          getStr([data.data])
        }
        recursiveFunction()

        this.saveTreeOnly([data.data])

      },
      //为树形结构设置唯一标识符
      saveTreeOnly (data) {
        var num=1
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.Content.variableName) {
                row.Content.Name=(row.Content.variableName.split("."))[1]
              }
              if(row.ChildDatas==undefined) {
                row.ChildDatas=[]
              }
              if(row.ChildDatas.length!=0) {
                row.keyId=num++
                getStr(row.ChildDatas)
              } else {
                row.keyId=num++
              }
            })
          }
          getStr(data)
        }
        recursiveFunction()
        this.treeList=data;
        this.treeListCopy=this.treeList;
        setTimeout(() => {
          this.screenType_fn('aec119cd-245d-4432-b97d-1a11646377c0')
        },1200);
      },
      recordTreeClick (a) {
        if(a.Content.variableName) {
          this.temp.variableName=a.Content.variableName;
        }
      },

      //树形结构筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },
      // 删除管理员
      delete_fn (v) {
        this.$confirm(`是否删除 ${v.deviceName}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          request({url: "/runningTime/deleteById?id="+v.id,method: "delete"}).then(res => {
            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            }
          })
        })

      },

      // 重置
      recaed (v) {
        request({url: "/runningTime/reset?id="+v.id,method: "put"}).then(res => {

          if(res.code==200) {
            this.$message({showClose: true,message: '重置成功',type: 'success'});
            this.getList();
          }
        })
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            if(!this.temp.variableName) {
              this.$message({showClose: true,message: '请选择变量名',type: 'info'});
              return
            }
            var data={
              deviceName: this.temp.deviceName,
              uid: this.temp.id,
              status: this.temp.status? 0:1,
              variableName: this.temp.variableName,
            }

            request({url: "/runningTime/save",method: "POST",data}).then(res => {
              console.log(res,111);
              if(res.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              }
            })

          } else {
            return false;
          }
        });
      },

      // 确认编辑
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            if(!this.temp.variableName) {
              this.$message({showClose: true,message: '请选择变量名',type: 'info'});
              return
            }
            var data={
              deviceName: this.temp.deviceName,
              status: this.temp.status? 0:1,
              variableName: this.temp.variableName,
            }

            request({url: "/runningTime/save",method: "POST",data}).then(res => {
              console.log(res,111);
              if(res.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              }
            })

          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.temp={}
        this.$nextTick(() => {

          this.$refs["temp"].clearValidate();
        });
      },

      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {

          this.$refs["temp"].clearValidate();
        });

      },

      // 获取抄表列表信息
      getList () {
        //对参数给值
        var d=[
          {
            "id": 330293992687617,
            "deviceName": "1#斜皮带",
            "variableName": "主楼1#.1#斜皮带电流",
            "totalTime": 644725457,
            "status": 0,
            "startTime": 1716884289000,
            "createTime": 1714094239000,
            "catalogueId": 330194875641857
          },
          {
            "id": 330294109452289,
            "deviceName": "1#斜皮带冲洗",
            "variableName": "主楼1#.1#斜皮带冲洗",
            "totalTime": 2165122,
            "status": 0,
            "startTime": 1716884289000,
            "createTime": 1714094296000,
            "catalogueId": 330194875641857
          },
          {
            "id": 330294344046593,
            "deviceName": "1#水泥螺旋1",
            "variableName": "主楼1#.1#水泥螺旋1电流",
            "totalTime": 553154,
            "status": 0,
            "startTime": 1716884290000,
            "createTime": 1714094411000,
            "catalogueId": 330194875641857
          },
          {
            "id": 330294472892417,
            "deviceName": "1#水泥螺旋2",
            "variableName": "主楼1#.1#水泥螺旋2电流",
            "totalTime": 3262565,
            "status": 0,
            "startTime": 1716884291000,
            "createTime": 1714094474000,
            "catalogueId": 330194875641857
          },
          {
            "id": 330294562617345,
            "deviceName": "1#水泥螺旋3",
            "variableName": "主楼1#.1#水泥螺旋3电流",
            "totalTime": 3159464,
            "status": 0,
            "startTime": 1716884291000,
            "createTime": 1714094517000,
            "catalogueId": 330194875641857
          },
          {
            "id": 330294696435713,
            "deviceName": "1#矿粉螺旋1",
            "variableName": "主楼1#.1#矿粉1螺旋电流",
            "totalTime": 2605638,
            "status": 0,
            "startTime": 1716884292000,
            "createTime": 1714094583000,
            "catalogueId": 330194875641857
          },
          {
            "id": 330294793414657,
            "deviceName": "1#矿粉螺旋2",
            "variableName": "主楼1#.1#矿粉2螺旋电流",
            "totalTime": 819096,
            "status": 0,
            "startTime": 1716884292000,
            "createTime": 1714094630000,
            "catalogueId": 330194875641857
          },
          {
            "id": 330294898692097,
            "deviceName": "1#膨胀剂螺旋1",
            "variableName": "主楼1#.1#膨胀剂主螺旋电流",
            "totalTime": 332084,
            "status": 0,
            "startTime": 1716884293000,
            "createTime": 1714094682000,
            "catalogueId": 330194875641857
          }
        ];
        d.map(v => {
          if(v.startTime) {
            v.startTime=this.parseTime(v.startTime,'{y}-{m}-{d} {h}:{i}:{s}')
          }
          if(v.createTime) {
            v.createTime=this.parseTime(v.createTime,'{y}-{m}-{d} {h}:{i}:{s}')
          }
          if(v.totalTime) {
            v.totalTime=(v.totalTime/1000/60/60).toFixed(1)
          }
        })
        this.dataList=d;
      },
      // 时间格式化
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      // 添加电表配置
      addMeterSet () {

      },
      // 修改状态
      switch_fn (a,v) {
        var data={
          deviceName: v.deviceName,
          uid: v.id,
          status: v.status? 0:1,
          variableName: v.variableName,
        }
        request({url: "/runningTime/save",method: "POST",data}).then(res => {
          console.log(res,111);
          if(res.code==200) {
            this.getList();
            this.$message({showClose: true,message: '修改成功',type: 'success'});
          }
        })
      },


    }
  }
</script>

<style scoped lang="scss">
  .tree-left {
    width: 3rem;
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
    background-color: #fff;
    margin-right: 8px;

    .btns {
      display: flex;
      // justify-content: space-evenly;
      margin-bottom: 8px;

      button {
        margin-right: 12px;
      }

      .el-button--mini {
        padding: 7px 10px !important;
      }

      .el-button+.el-button {
        margin-left: 0px;
      }
    }

    .search {
      display: flex;
      justify-content: center;
      margin-bottom: 12px;
    }

  }

  .right-table {
    width: calc(100% - 3.08rem);
    height: 100%;
    padding: 2px 20px 20px 20px;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;

    .mycharts {
      display: flex;

      .charts-left {
        width: 35%;
      }

      .charts-right {
        width: 70%;
      }
    }
  }

  .mymetermanager {
    width: 100%;
    height: 100%;

    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;
    }

    .myinput-mill {
      /deep/.el-input__inner {
        width: 90px;
      }

      /deep/.el-input {
        width: 90px !important;
      }
    }
  }

  .searchContainer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 0px;
  }

  .searchContainer>div {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 0;
  }

  .searchContainer label {
    margin-right: 6px;
  }

  .searchContainer input {
    border-color: #DCDFE6;
    min-width: 130px;
    height: 36px;
    box-sizing: border-box;
    margin-right: 10px;
  }

  .searchContainer>>>.selection-body {
    display: inline-flex;
    padding: 0;
    margin-right: 20px;
  }

  .searchContainer>>>.selection>p {
    line-height: 34px;
    height: 34px;
    padding: 0;
  }

  .selectDateTime {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 176px;
    height: 34px;
    padding: 0 6px;
    background: #FFFFFF;
    border-radius: 6px;
    border: solid 1px #DCDFE6;
    margin-right: 20px;
  }

  .selectDateTime>span {
    width: 140px;
    line-height: 34px;
    height: 100%;
    cursor: pointer;
  }

  .selectDateTime>img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .searchContainer>button {
    height: 36px;
    background-color: #409EFF;
    color: #FFFFFF;
    padding: 0 18px;
    margin-left: 10px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .infoListContainer {
    /* padding: 0 20px 250px 20px; */
    height: calc(100% - 115px);
  }

  .infoListContainer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .infoListContainer::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F0F0F0;
  }

  .infoListContainer::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-thumb {
    background-color: #CACACA;
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87CF64;
    border-radius: 4px;
    color: #87CF64;
    background-color: #F0F9EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #F9A6A6;
    border-radius: 4px;
    color: #F9A6A6;
    background-color: #FEF1F1;
    line-height: 28px;
    padding: 0 6px;
  }

  .waitStatus {
    display: inline-block;
    border: solid 1px #E6A23C;
    border-radius: 4px;
    color: #E6A23C;
    background-color: #FDF6EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .normalStatus:hover,
  .wrongStatus:hover,
  .waitStatus:hover {
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
  }

  .operateBtn {
    display: inline-block;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 6px;
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
    margin-right: 8px;
    cursor: pointer;
  }

  .noDrop {
    cursor: no-drop !important;
  }

  .marginRightNone {
    margin-right: 0;
  }

  @media screen and (max-width: 1600px) {
    .searchContainer label {
      display: block;
      margin-right: 0;
    }

    .infoListContainer {
      height: calc(100% - 96px);
    }
  }
</style>